/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const accessTokenResponseV4Schema = z
  .object({
    accessToken: z
      .string()
      .min(1)
      .default('')
      .describe('The JWT access token to send as `Authorization: Bearer <token>`.'),
    expiresOn: z.iso
      .datetime({ offset: true, local: true })
      .default('')
      .describe('UTC moment the access token expires.'),
  })
  .describe(
    'A freshly issued V4 access token and when it expires. The refresh token travels in its cookie.\r\n(Named for the RESPONSE — EP.Lib.Services.Auth.TokenPairV4 is the internal pair that also\r\ncarries the refresh token, which never leaves the API in a body.)'
  )
